import React, { useEffect, useState } from "reactn";
import { useParams } from 'react-router-dom'
import { Row, Col, Form, Input, Button, Card, message, Select, Switch, DatePicker, Alert, InputNumber } from 'antd';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { FileInputSingle, QuestionSetPicker } from '../components';
import { Link } from 'react-router-dom';
import { useCallback } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import firebaseDb from '../firebase';
import moment from 'moment';
import axios from 'axios';
import { nanoid } from 'nanoid';

const NotificationDetail = (props) => {
    let params = useParams()
    let history = useHistory()
    let id = params.id !== "add" ? params.id : false;

    let newRecord = {
        title: null,
        text: null,
        active: true,
        order:1,
        date: moment(new Date()),
    }

    let [data, setData] = useState(id ? [] : newRecord);
    let [errors, setErrors] = useState([]);
    let [loading, setLoading] = useState(id ? true : false);
    let [validationCheck, setValidationCheck] = useState(false)

    //onetime run
    useEffect(() => {
        if (id) {
            setLoading(true)
            get()
        }
    }, [id]);

    let get = async () => {
        const notificationRef = doc(firebaseDb, "notification", id);
        const notificationSnap = await getDoc(notificationRef);

        if (notificationSnap.exists()) {
            setData({
                ...notificationSnap.data(),
                id: notificationSnap.id
            });
            setLoading(false)
        }

    }

    let validate = useCallback(() => {
        let errors = {};

        if (data.title === null)
            errors.title = 'Zorunlu Alan!'

        if (data.text === null)
            errors.text = 'Zorunlu Alan!'

        errors.all = Object.getOwnPropertyNames(errors).map(n => errors[n]);
        errors.hasError = errors.all.length > 0;
        return errors;
    }, [data]);

    useEffect(() => { if (validationCheck) setErrors(validate()) }, [validationCheck, data, validate]);

    let save = async () => {
        console.log(data)

        setValidationCheck(true)
        let err = validate()

        if (err.hasError) {
            setErrors(err)
            window.scrollTo({ top: 20, behavior: 'smooth' });
        }
        else {

            if (data.date._d)
                data.date = data.date._d

            if (id) {
                await setDoc(doc(firebaseDb, "notification", id), { ...data });
                message.success("Bilgiler güncellendi", 2);
                history.push('/notifications')

            } else {
                id = nanoid(20)
                data.id = id
                await setDoc(doc(firebaseDb, "notification", id), { ...data });
                message.success("Kayıt Başarılı bir şekilde eklendi.", 2);
                history.push('/notifications')
            }
        }
    };

    const { Option } = Select;

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Bildirimler"}</h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/notifications">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="form-wrap">
                <Card title={id ? "Düzenle" : "Ekle"} loading={loading}>
                    <Form layout="horizontal" size={"large"} onFinish={save}>

                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Başlık" required help={errors.title} validateStatus={errors.title ? 'error' : 'success'}>
                                    <Input className="button4" name="title" value={data.title} onChange={e => setData({ ...data, title: e.target.value })} />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Metin" required help={errors.text} validateStatus={errors.text ? 'error' : 'success'}>
                                    <Input className="button4" name="text" value={data.text} onChange={e => setData({ ...data, text: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Durumu" help={errors.active} validateStatus={errors.active ? 'error' : 'success'}>
                                    <Switch className="button4" checked={data.active ? true : false} checkedChildren="Aktif" unCheckedChildren="Pasif" onChange={v => setData({ ...data, active: v })} />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Sıra" help="Sıra seçilmediği taktirde sıralaması 1 olacak şekilde ayarlanır.">
                                    <InputNumber name="order" value={data.order} onChange={v => setData({ ...data, order: v })} />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row direction="row">
                            <Col span={24}>
                                <Form.Item>
                                    <Button className="button4" type="primary" disabled={loading} htmlType="submit" size="large" block > KAYDET </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default NotificationDetail;
